import { ValidationObj } from "components/NewPassInput";

export const checkValid = (value: string) => {

    const upperCasePattern = /^(.*[A-Z].*)$/;
    const lowerCasePattern = /^(.*[a-z].*)$/;
    const numberPattern = /^(.*[0-9].*)$/;
    const specialPattern = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    const specialCharacterAtBeginning = /^[\W|_]/g;

    let newValidationObject: ValidationObj = {};

    const hasLowerCase = lowerCasePattern.test(value);
    const hasUpperCase = upperCasePattern.test(value);
    const hasCorrectLength = value.length > 9;
    const hasNumber = numberPattern.test(value);
    const hasSpecialChar = !!value.match(specialPattern) && !!value;
    const hasNoSpecialCharacterAtBeginning = !value.match(specialCharacterAtBeginning);

    newValidationObject = {
      hasCorrectLength,
      hasLowerCase,
      hasUpperCase,
      hasNumber,
      hasSpecialChar,
      hasNoSpecialCharacterAtBeginning,
    };

    return newValidationObject;
};

export const brokenRule = (items) => {
    const isInvalid =
        items && Object.values(items).some((value) => value === false);

    return isInvalid;
}